export enum CoursePromotionType {
  MAIN = "MAIN",
  COURSE_MAIN = "COURSE_MAIN"
}
